export var GeoAreaMatchStatus;
(function (GeoAreaMatchStatus) {
    GeoAreaMatchStatus["MATCHED"] = "MATCHED";
    GeoAreaMatchStatus["NOT_MATCHED"] = "NOT_MATCHED";
})(GeoAreaMatchStatus || (GeoAreaMatchStatus = {}));
var detectGeographicMatch = function (topology, geographicAreaKeys) {
    var features = topology.features;
    var matchedGeographicalAreas = 0;
    features.forEach(function (_a) {
        var _b = _a.properties, name = _b.name, iso3166 = _b.iso_3166_2, postAbbreviation = _b.postAbbreviation;
        if (geographicAreaKeys.includes(name) ||
            geographicAreaKeys.includes(iso3166) ||
            geographicAreaKeys.includes(postAbbreviation)) {
            matchedGeographicalAreas++;
        }
    });
    if (geographicAreaKeys.length > 0 && matchedGeographicalAreas === 0) {
        return GeoAreaMatchStatus.NOT_MATCHED;
    }
    return GeoAreaMatchStatus.MATCHED;
};
export default detectGeographicMatch;
